










































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { FeeDesignationService } from '../../service/FeeDesignationService';
import { AgentService } from '../../service/AgentService';
import { ClientService } from '../../service/ClientService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxPopup
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxSelectBox } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import {
  AvailableFeeDesignationsSearchColumns,
  FeeDesignationsSearchColumns
} from '../../models/Fees/FeeDesignationSearchColumns';
import { SelectOption } from '../../models/SelectOption';
import { AgentDto } from '../../models/agent/AgentDto';
import notify from 'devextreme/ui/notify';

@Component({
  components: {
    DxSelectBox,
    DataGrid,
    DxColumn,
    DxEditing,
    DxForm,
    DxFormItem,
    DxHeaderFilter,
    DxItem,
    DxLookup,
    DxPopup
  }
})
export default class FeeDesignationsGrid extends Vue {
  clients: Array<SelectOption> = [];
  allAgents: Array<SelectOption> = [];
  filteredAgents: Array<SelectOption> = [];
  feeTypes: Array<SelectOption> = [];
  selectedClient: Guid = '';
  availableFeeDesignationsSearchColumns: Array<SelectOption> = AvailableFeeDesignationsSearchColumns;
  dataGrid: any;
  feeDesignationsService: FeeDesignationService;
  feeDesignationsCustomStoreOptions: DevExpress.data.CustomStoreOptions;
  
  agentService: AgentService = new AgentService();
  clientService: ClientService = new ClientService();

  @Watch('selectedClient')
  onSelectedClientChange() {
    this.filteredAgents = [];
    if(this.selectedClient) {
      this.clientService.getAgentByClientId(this.selectedClient).then(result => {
        this.filteredAgents = result.map(a => {
          return { text: a.AgentName, value: a.AgentId };
        });
      });
    }
  }

  constructor() {
    super();
    this.feeDesignationsService = new FeeDesignationService(
      '/api/FeeDesignations'
    );
    this.feeDesignationsCustomStoreOptions = {
      key: 'FeeDesignationId',
      load: loadOptions => this.feeDesignationsService.search(loadOptions),
      insert: values => this.feeDesignationsService.create(values),
      update: (key, values) => this.feeDesignationsService.edit(key, values),
      remove: key => this.feeDesignationsService.delete(key)
    };
  }

  mounted() {
    this.loadData();
  }

  async loadData() {
    let clients = await this.clientService.getAll();
    this.clients = clients.map(c => {
      return { text: c.ClientName, value: c.ClientId };
    });

    let agents = await this.agentService.getAll();
    this.allAgents = agents.map(a => {
      return { text: a.AgentName, value: a.AgentId };
    });

    let feeTypes = await this.feeDesignationsService.getTypes();
    this.feeTypes = feeTypes.map(t => {
      return { text: t.Name, value: t.FeeTypeId };
    });
  }

  dataGridInitialized(e: any): void {
    this.dataGrid = e.component;
  }

  saveEditData(): void {
    if (this.dataGrid) {
      this.dataGrid.focus();
      this.dataGrid.saveEditData();
    }
  }

  popupShowing(e: any) {
    // Couldn't find a configuration option for this, so changing the the order and style of Save and Cancel when loading the dialog.
    var toolbarItems = e.component.option('toolbarItems');
    toolbarItems[0].options.stylingMode = 'contained';
    toolbarItems[1].options.stylingMode = 'contained';
    toolbarItems[1].options.type = 'normal';
    e.component.option('toolbarItems', toolbarItems);
  }

  popupHiding(e: any) {
    let toast = document.getElementById('SelectedAgentWarningToast');
    if(toast) {
      toast.remove();
    }
  }

  initNewRow(e: any) {
    e.data = {
      ClientId: this.selectedClient,
      FeeTypeId: 0,
      SearchColumn: 'UTBMS'
    };
  }

  rowUpdating(e: any) {    
    // Add back any data not edited
    e.newData = Object.assign({}, e.oldData, e.newData);
  }

  editingStart(e: any) {
    // If an agent id is set, but not in the filtered list, show a warning
    if(e.data && e.data.AgentId && !this.filteredAgents.some(a => a.value === e.data.AgentId)) {
      let warningMessage = 'The selected agent for this rule is no longer associated with this client. Please select a new agent or leave empty to apply to all.';
      notify({ 
        message: warningMessage, 
        position: { my: 'center', at: 'center', of: window, offset: '0 -200' },
        minWidth: '40%',
        closeOnClick: true,
        elementAttr: { id: 'SelectedAgentWarningToast' }
      }, 'warning', 10000);
    }
  }

  customizeNullText(info: any) {
    return info.valueText === '' ? 'ALL' : info.valueText;
  }
}
